import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/ProductsDetails/AboutOilMeals.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
const OilMeals = () => {
  return (
    <>
        <PageBanner title='Oil Meals ' bannerBg={bannerBg} currentPage=' Oil Meals' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Oil Meals 
                </h2>
                <h6>(Solvent Extracted De-Oiled Cakes)</h6>
                <p>
                De-Oiled Cake (DOC) or Meal is a free-flowing, coarse granular substance derived from cleaned seeds or oil cakes through a series of preparatory physical processes, followed by multistage extraction. This product is made from NON-GMO seeds in an advanced, hygienically controlled processing facility. 
                </p>
                <br></br>
                <p>
                Rich in high-quality proteins, De-Oiled Cake / Meal is a protein-dense material free from cholesterol. 
                </p>
                <br></br>
                <p>
                With its well-balanced nutritional profile, it is widely used in the production of nutritious food. . 
                </p>
                <br></br>
                <p>
              
                In India, De-Oiled Cake / Meal serves as a key ingredient in cattle and poultry feed. Additionally, it is exported to various countries across Far East Asia, North East Asia, and the Mediterranean region, where it is highly valued by millers. 
                </p>
                <br></br>
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              <Link to="/contact" className="theme-btn style-3 mt-30">
              Contact
              </Link>
            </div>
          </div>
         
        </div>
      </section> 
    </>
  )
}

export default OilMeals
